import React from "react";
import {useTranslation} from "react-i18next";
import {SelectField} from "./FilterComponentStyles";
import {useFetch} from "../../../hooks/useFetch";
import {useStore} from "../../../hooks/useStore";

const WalletInvoiceVendorFilter = ({
    value,
    onChange,
    showLabel = true,
    showAllOption = true,
    showNoneOption = true,
    mode = undefined,
    selectMarginBottom = "20px",
    allowClear = false,
    condition = true,
    initialCall = true,
    initialValue = [],
    loading = false,
    disabled
}) => {
    const {t} = useTranslation();
    const stores = useStore();

    const [walletInvoiceVendorResultLoading, walletInvoiceVendorResult] = useFetch({
        defaultDataValue: initialValue,
        fetchFn: stores.walletStore.getWalletInvoiceVendors.bind(null, {}),
        dependencies: [],
        initialCall: initialCall,
        condition: condition
    });

    return (
        <React.Fragment>
            {showLabel && <h5>{"Entegratör"}</h5>}
            <SelectField
                loading={walletInvoiceVendorResultLoading || loading}
                disabled={walletInvoiceVendorResultLoading || loading || disabled}
                showSearch
                value={value}
                data-testid="wallet_invoice_vendor"
                mode={mode}
                onChange={onChange}
                mb={selectMarginBottom}
                allowClear={allowClear}
            >
                {showAllOption ? (
                    <SelectField.Option data-testid="option" value={"all"}>
                        {t("filters.all", {ns: "common"})}
                    </SelectField.Option>
                ) : (
                    <></>
                )}
                {walletInvoiceVendorResult?.vendors?.map(vendor => (
                    <SelectField.Option data-testid="option" value={vendor.code}>
                        {vendor.label}
                    </SelectField.Option>
                ))}
                {showNoneOption ? (
                    <SelectField.Option data-testid="option" value={"none"}>
                        {t("filters.noneVendor", {ns: "common"})}
                    </SelectField.Option>
                ) : (
                    <></>
                )}
            </SelectField>
        </React.Fragment>
    );
};

export default WalletInvoiceVendorFilter;
